<template>
  <el-dialog :visible.sync="visible" :title="title ? title : (submitBtn.hide ? `查看${className || ''}详情` : (formData.modelName || (!colData || !colData.id ? $t('page.add') : $t('page.update'))))"  :width="updateData.width" :close-on-click-modal="false" :before-close="beforeClose" :close-on-press-escape="false" class="dv_update" :class="{'task': className && className === '任务'}">
    <el-form :model="formData" ref="dataForm" :style="{'max-height':maxHeight,'overflow-y':'scroll'}">
      
      <div class="tabs" style="position:sticky; top:0; background-color:white; z-index:10; padding:10px 0; border-bottom:1px solid #eee;" v-if="className && className === '任务'">
        <span @click="tab = 1" :class="{'active': tab === 1}">任务基础信息</span>
        <span @click="tab = 2" :class="{'active': tab === 2}">任务详情</span>
      </div>

      <div v-if="className && className === '米星卡等级' && id" class="miCardLevel">
        <table style="width: 100%;">
          <tr class="title">
            <td>米星卡等级</td>
            <td>米分范围</td>
            <td>星级权益</td>
            <td>状态</td>
            <td>任务米币百分比</td>
          </tr>
          <tr v-for="list in editList">
            <td>
              <el-select v-model="list.grade" :disabled="true" placeholder="米星卡等级" size="mini" style="width: 100px;">
                <el-option v-for="(value,key) in gradeList" :label="value" :value="Number(key)" :key="key"></el-option>
              </el-select>
            </td>
            <td>
              <el-input-number size="mini" v-model="list.scoreRangeBegin" label="开始" ></el-input-number>
              <el-input-number size="mini" v-model="list.scoreRangeEnd" label="结束"></el-input-number>
            </td>
            <td>
              <el-select v-model="list.conditionAppr" placeholder="星级权益" style="width: 120px;" size="mini">
                <el-option :value="0" label="无"></el-option>
                <el-option :value="1" label="快速兑换审批通道"></el-option>
              </el-select>
            </td>
            <td>
              <el-select v-model="list.isDelete" placeholder="状态" style="width: 80px;" size="mini">
                <el-option :value="1" label="启用"></el-option>
                <el-option :value="2" label="禁用"></el-option>
              </el-select>
            </td>
            <td>
              <el-input-number v-model="list.conditionPer" label="任务米币百分比" size="mini" style="width: 100px;"></el-input-number> %
            </td>
          </tr>          
        </table>
      </div>
      <div v-else>
        <div v-for="(col,index) in formData.cols" :key="col.field + index">
          <el-form-item :class="col.position" :required="typeof col.required == 'function'?col.required(updateModel,col):col.required" v-if="col.type != 10 && (col.tab || 1) === tab" :style="{'display':(typeof col.hidden == 'function'?col.hidden(updateModel,col):col.hidden)?'none': 'flex'}" :label="typeof col.title == 'function' ? col.title(updateModel,col) : col.title" :key="'item' + col.field + index">
            <!--上傳圖片-->
            <el-upload
              v-if="col.upload && !submitBtn.hide"
              :drag="col.drag"
              :data="col.option"
              :headers="uploadHeaders"
              :accept="col.accept"
              class="upload-demo"
              :on-success="(response, file, fileList)=> uploadSuc(response, file, fileList, col)"
              :on-error="(err, file, fileList) => uploadFail(response, file, fileList, col)"
              :action="col.action || defaultUploadUrl"
              :show-file-list="false"
              :auto-upload="true"
              :before-upload="(file) => uploadProgress(file,col,col.maxfileSize,col.accept)"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text"><span v-if="col.drag">{{$t('page.drag')}}</span><em>{{$t('page.clickUpload')}}</em></div>
              <span>{{col.loading}}</span>
            </el-upload>
            <img v-if="col.upload && col.data && !col.hidePreview === true" style="width: 150px" :src="col.data">

            <!--普通input框 type:1-->
            <el-input :readonly="typeof col.readonly == 'function'?col.readonly(updateModel,col):col.readonly" :disabled="submitBtn.hide || col.disabled || (typeof col.readonly == 'function'?col.readonly(updateModel,col):col.readonly)" :type="col.textType" :autosize="true" v-if="!col.type || col.type == 1" @input="handleInput($event, col)" v-model="col.data" :placeholder="col.placeholder==null?(typeof col.title == 'function'?col.title(updateModel,col):col.title):col.placeholder" :maxlength="col.maxlength" show-word-limit></el-input>

            <el-input-number v-if="col.type == 18" :min="0"  :max="99990" @blur="col.data=$event.target.value.trim()" v-model="col.data" :placeholder="col.placeholder==null?col.title:col.placeholder" :maxlength="col.maxlength"/>
            <span class="separator" v-if="col.type == 18">-</span>
            <el-input-number v-if="col.type == 19" :min="0" :max="99999" @blur="col.data=$event.target.value.trim()" v-model="col.data" :placeholder="col.placeholder==null?col.title:col.placeholder" :maxlength="col.maxlength" />
            <span class="separator" v-if="col.type == 19" style="color:rosybrown;">输入框只允许输入正整数，且右区间值必须大于左区间值</span>
            <el-input-number v-if="col.type == 20" :min="0" :max="100" @blur="col.data=$event.target.value.trim()" v-model="col.data" :placeholder="col.placeholder==null?col.title:col.placeholder" :maxlength="col.maxlength" />
            <span class="separator" v-if="col.type == 20">%</span>
            
            <!--select框 type:2-->
            <el-select :disabled="submitBtn.hide || (typeof col.readonly == 'function'?col.readonly(updateModel,col):col.readonly)" :multiple="col.multiple" @input="change()" @change="changeValue(updateModel,col,formData.cols)" v-if="col.type == 2" :clearable="col.clearable === undefined ? true : (typeof col.clearable === 'function' ? col.clearable(updateModel, col) : col.clearable)" v-model="col.data" filterable :placeholder="typeof col.title == 'function' ? col.title(updateModel,col) : col.title">
              <el-option v-if="col.optionList && col.optionList instanceof Array" v-for="(option,key) in col.optionList" :label="option.value" :value="col.isNumber?Number(option.key):option.key" :key="key"></el-option>
              <el-option v-if="col.optionList && !(col.optionList instanceof Array)" v-for="(value,key) in col.optionList" :label="value" :value="col.isNumber?Number(key):key" :key="key"
              :disabled="(key === 'all' && col.data != null && col.multiple && col.data.length > 0 && !col.data.includes('all')) || (key !== 'all' && col.data != null && col.multiple === true && col.data.includes('all')) || (key === '0' && col.data != null && col.multiple && col.data.length > 0 && !col.data.includes('0')) || (key !== '0' && col.data != null && col.multiple === true && col.data.includes('0'))"
              ></el-option>
              <el-option v-if="col.optionListArrRender" v-for="(option,key) in (col.optionListArrRender?col.optionListArrRender(updateModel,col):[])" :label="option.value" :value="col.isNumber?Number(option.key):option.key" :key="key"></el-option>
              <el-option v-if="col.optionListObjRender" v-for="(value,key) in (col.optionListObjRender?col.optionListObjRender(updateModel,col):{})" :label="value" :value="col.isNumber?Number(key):key" :key="key"></el-option>
            </el-select>

            <!--单选 type:3-->
            <el-radio-group :disabled="typeof col.readonly == 'function'?col.readonly(updateModel,col):col.readonly || col.disabled" v-if="col.type == 3" @input="change()"  v-model="col.data">
              <el-radio v-if="col.optionList instanceof Array" v-for="option in col.optionList" :label="col.isNumber?Number(option.key):option.key" :key="key">{{option.value}}</el-radio>
              <el-radio v-if="!(col.optionList instanceof Array)" v-for="(value,key) in col.optionList" :label="col.isNumber?Number(key):key" :key="key">{{value}}</el-radio>
            </el-radio-group>

            <!--复选框 type:4-->
            <el-checkbox :indeterminate="col.isIndeterminate" :disabled="typeof col.readonly == 'function'?col.readonly(updateModel,col):col.readonly" v-if="col.type == 4 && col.hasCheckAll" v-model="col.checkAll" @change="(val)=>handleCheckAllChange(val,col)">{{col.checkAllName || $t('page.selectAll')}}</el-checkbox>
            <el-checkbox-group style="margin:auto 20px"  :disabled="typeof col.readonly == 'function'?col.readonly(updateModel,col):col.readonly || col.disabled"  v-if="col.type == 4" @input="change()"  v-model="col.data" @change="(val)=>handleCheckedCitiesChange(val,col)">
              <el-checkbox v-if="col.optionList instanceof Array" v-for="(option,key) in col.optionList" :label="col.isNumber?Number(option.key):option.key" :key="key">{{option.value}}</el-checkbox>
              <el-checkbox v-if="!(col.optionList instanceof Array)" v-for="(value,key) in col.optionList" :label="col.isNumber?Number(key):key" :key="key">{{value}}</el-checkbox>
            </el-checkbox-group>

            <!--时间 type:5-->
            <el-date-picker :readonly="typeof col.readonly == 'function'?col.readonly(updateModel,col):col.readonly || col.disabled || submitBtn.hide"  v-if="col.type == 5" @input="change()" v-model="col.data"  type="datetime" :value-format="col.format?col.format:'timestamp'" :placeholder="col.title"></el-date-picker>

            <!--富文本编辑器 type:6,quill底层涉及到html的id，visible是把模态框隐藏，所以此次注意visible为false时要把quill干掉而不是隐藏，不然多个模态框时会再次id冲突，导致富文本显示异常-->
            <!--noTable:是否支持table样式（目前:36要求支持,108要求不支持）-->
            <div v-if="col.type == 6 && col.demo === true" @click="openDemo" style="color: var(--brand-primary); text-align: right; cursor: pointer;">查看奖品详情示例</div>
            <quill v-if="col.type == 6 && visible && !submitBtn.hide" :uploadUrl="col.uploadUrl" :quillId="col.field" ref="quill" :disabled="submitBtn.hide"></quill>
            <div v-if="col.type == 6 && submitBtn.hide" v-html="col.data"></div>


            <!--计数器 type:7-->
            <el-input-number :disabled="submitBtn.hide || (typeof col.readonly == 'function'?col.readonly(updateModel,col):col.readonly)" v-if="col.type == 7" v-model="col.data" :min="col.min" :precision="col.precision" :label="typeof col.title == 'function' ? col.title(updateModel,col) : col.title"></el-input-number> <label v-if="col.unit">单位:{{ col.unit }}</label>

            <!--分类多选框 type:8-->
            <el-checkbox-group :disabled="typeof col.readonly == 'function'?col.readonly(updateModel,col):col.readonly"  v-if="col.type == 8"  @input="change()"  v-model="col.data" @change="(val)=>handleCheckedCitiesChangeMu(val,col)">
              <div v-for="select in col.selectList">
                <div>
                  <el-checkbox :indeterminate="select.isIndeterminate"  v-model="select.checkAll" @change="(val)=>handleCheckAllChangeMu(val,select,col)" :label="select.check">{{select.checkAllName}}</el-checkbox>
                </div>
                <div style="margin:auto 20px" v-if="select.optionList">
                  <el-checkbox v-if="select.optionList instanceof Array" v-for="(option,key) in select.optionList" :label="col.isNumber?Number(option.key):option.key" :key="key">{{option.value}}</el-checkbox>
                  <el-checkbox v-if="!(select.optionList instanceof Array)" v-for="(value,key) in select.optionList" :label="col.isNumber?Number(key):key" :key="key">{{value}}</el-checkbox>
                </div>
                <div style="margin:auto 20px" v-if="select.styleList" v-for="(optionList,key) in select.styleList">
                  <el-checkbox v-if="optionList instanceof Array" v-for="option in optionList" :label="col.isNumber?Number(option.key):option.key" :key="key">{{option.value}}</el-checkbox>
                  <el-checkbox v-if="!(optionList instanceof Array)" v-for="(value,key) in optionList" :label="col.isNumber?Number(key):key" :key="key">{{value}}</el-checkbox>
                </div>

              </div>
            </el-checkbox-group>

            <!--开始结束时间 type:9-->
            <el-date-picker :range-separator="$t('page.to')"
                            :start-placeholder="$t('page.startTime')"
                            :end-placeholder="$t('page.endTime')" 
                            :readonly="typeof col.readonly == 'function'?col.readonly(updateModel,col):col.readonly"
                            :disabled="submitBtn.hide || col.disabled" v-if="col.type == 9" 
                            @input="change()" 
                            v-model="col.data"  
                            type="datetimerange" 
                            :value-format="col.format?col.format:'timestamp'" 
                            :placeholder="col.title"
                            :default-time="['00:00:00', '23:59:59']"
                            ></el-date-picker>

            <!--上传文件 type:11-->
            <div v-if="col.type == 11">
              <el-upload
                :action="col.action || defaultUploadUrl"
                class="upload-demo"
                :data="col.option"
                :headers="uploadHeaders"
                :accept="col.accept"
                drag
                :on-success="(response, file, fileList)=> uploadFileSuc(response, file, fileList, col)"
                :on-error="(err, file, fileList) => uploadFail(response, file, fileList, col)"
                :show-file-list="false"
                :auto-upload="true"
                :before-upload="(file)=> uploadFileProgress(file,col)">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">{{$t('page.drag')}}<em>{{$t('page.clickUpload')}}</em></div>
                <span>{{col.loading}}</span>
              </el-upload>
              <el-input :readonly="col.readonly" v-model="col.fileName"></el-input>
              <el-button v-if="col.downUrl" style="margin: 10px auto"  type="primary"  @click="downTemplate(col.downUrl)">{{$t('page.downTemplate')}}</el-button>
            </div>

            <!--默认从变量 type:12,请注意使用this.$set(col,"data",value)方式设置默认值-->
            <el-input :readonly="typeof col.readonly == 'function'?col.readonly(updateModel,col):col.readonly" :disabled="col.disabled" :type="col.textType"  v-if="col.type == 12"   v-model="col.data" :placeholder="col.placeholder==null?col.title:col.placeholder"></el-input>

            <!--select框 type:13-->
            <el-select :readonly="typeof col.disabled == 'function'?col.readonly(updateModel,col):col.readonly" :disabled="col.disabled" :multiple="col.multiple" @input="change()" v-if="col.type == 13" v-model="col.data" :placeholder="col.title">
              <el-option v-if="col.optionList && col.optionList instanceof Array" v-for="(option,key) in col.optionList" :label="option.value" :value="col.isNumber?Number(option.key):option.key" :key="key"></el-option>
              <el-option v-if="col.optionList && !(col.optionList instanceof Array)" v-for="(value,key) in col.optionList" :label="value" :value="col.isNumber?Number(key):key" :key="key"></el-option>
              <el-option v-if="col.optionListArrRender" v-for="(option,key) in (col.optionListArrRender?col.optionListArrRender(updateModel,col):[])" :label="option.value" :value="col.isNumber?Number(option.key):option.key" :key="key"></el-option>
              <el-option v-if="col.optionListObjRender" v-for="(value,key) in (col.optionListObjRender?col.optionListObjRender(updateModel,col):{})" :label="value" :value="col.isNumber?Number(key):key" :key="key"></el-option>
            </el-select>


            <!--Ueditor type:14-->
            <Ueditor v-if="col.type == 14 && visible" :col="col"></Ueditor>

            <!--cascader選擇器 type:15-->
            <el-cascader v-if="col.type == 15" v-model="col.data" :options="col.optionList" :props="{ expandTrigger: 'hover', checkStrictly:col.checkStrictly?col.checkStrictly:false, emitPath: col.emitPath }" filterable clearable></el-cascader>

            <!--tinyeditor type:16-->
            <tinyeditor v-if="col.type == 16 && visible" :col="col"></tinyeditor>

            <!--上传影音 type:17-->
            <div v-if="col.type == 17">
              <el-upload
                :action="col.action || defaultUploadUrl"
                class="upload-demo"
                :data="col.option"
                :headers="uploadHeaders"
                :accept="col.accept"
                drag
                :on-success="(response, file, fileList)=> uploadMediaSuc(response, file, fileList, col)"
                :on-error="(err, file, fileList) => uploadFail(response, file, fileList, col)"
                :show-file-list="false"
                :auto-upload="true"
                :before-upload="(file)=> uploadProgress(file,col)">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">{{$t('page.drag')}}<em>{{$t('page.clickUpload')}}</em></div>
                <span>{{col.loading}}</span>
              </el-upload>
              <video :key="col.data.url" v-if="col.mediaType === 0 && col.data && col.data.url && col.data.type" width="320" height="180" controls>
                <source :src="col.data.url" :type="col.data.type">
                Your browser does not support the video tag.
              </video>
              <audio :key="col.data.url" v-if="col.mediaType === 1 && col.data && col.data.url && col.data.type" controls>
                <source :src="col.data.url" :type="col.data.type">
                Your browser does not support the audio tag.
              </audio >
              <el-input :readonly="col.readonly" v-model="col.data.url"></el-input>
            </div>

            <!--如果需要带按钮-->
            <el-button style="margin:10px auto" type="primary" v-if="col.btn" @click="col.click(updateModel,col)">{{col.btn}}</el-button>

            <!-- 广告Banner管理 -->
            <banner-template v-if="col.type == 30" :uploadHeaders="uploadHeaders" :adId="adId" :col="col" v-model="col.data" />

            <!-- 任务 -->
            <div v-if="col.type == 31">

              <!-- 新手任务 -->
              <newtask-template
                ref="task" 
                v-if="bigTaskId === 1 && (taskName === 'perInformatin' || taskName === 'verifIdentity')" 
                v-model="col.data"
                :disabled="submitBtn.hide"
              />

              <!-- 视频任务 -->
              <div v-else-if="bigTaskId === 2">
                <el-upload
                    v-if="!submitBtn.hide"
                    :drag="col.drag"
                    :data="col.option"
                    :headers="uploadHeaders"
                    accept=".mp4,.webm"
                    class="avatar-uploader"
                    :on-success="(response, file, fileList)=> uploadSuc(response, file, fileList, col)"
                    :on-error="(err, file, fileList) => uploadFail(response, file, fileList, col)"
                    :action="col.action || defaultUploadUrl"
                    :show-file-list="false"
                    :auto-upload="true"
                    :before-upload="(file) => uploadProgress(file,col,10,'.mp4,.webm')"
                  >
                  <el-button type="success" size="small" class="el-icon-upload">上传视频</el-button>
                  <span style="font-size: 12px;">{{col.loading}}</span>
                  </el-upload>
                  <video v-if="col.data && (col.data.endsWith('.mp4') || col.data.endsWith('.webm'))" width="320" height="180" controls preload="metadata" :key="col.data">
                    <source :src="col.data" type="video/mp4">
                  </video>
                  <el-input :disabled="submitBtn.hide" @input="change()" v-model="col.data"></el-input>
              </div>

              <!-- 问卷任务 -->
              <question-template 
                v-else
                v-model="col.data" 
                :uploadHeaders="uploadHeaders" 
                :disabled="submitBtn.hide"
                :addFrom="addFrom"
                @changeAddFrom="changeFrom"
              />
            </div>

            <!-- 查看任务 -->
            <div v-if="col.type == 33">
              <taskTemplate :value="col.data" :questionContent="updateModel['questionContent']" :bigTaskId="updateModel['bigTaskId']" :videoDuration="updateModel['videoDuration']"></taskTemplate>
            </div>

            <!-- 兑换申请 -->
            <div v-if="col.type == 32" class="exchange_record">
              <div v-if="updateModel['exchangeType'] === 1 || colData.approveChange === 3" class="price">
                <el-input v-model="col.data" :placeholder="colData.approveChange === 3 ? '取消原因' : '兑换方式为直充时，需要输入充值金额'"></el-input>
              </div>
              <div v-else>
                <div class="price"><el-input v-model="cardNo" placeholder="请输入卡号"></el-input></div>
                <div class="price"><el-input v-model="cardPwd" placeholder="请输入卡密"></el-input></div>            
              </div>
            </div>

            <!--上传产品模板 type:34-->
            <div v-if="col.type == 34" style="display: flex; gap: 10px; align-items: baseline;">
              <el-upload
                :ref="'upload' + index"
                :action="col.action || defaultUploadUrl"
                :limit="1"
                class="upload-demo"
                :data="col.option"
                :headers="uploadHeaders"
                :accept="col.accept"                
                :on-success="(response, file, fileList)=> uploadFileSuc(response, file, fileList, col)"
                :on-error="(err, file, fileList) => uploadFail(response, file, fileList, col)"
                :show-file-list="true"
                :auto-upload="false"
                :before-upload="(file)=> uploadFileProgress(file,col)">
                <el-button icon="el-icon-upload2">选择文件</el-button>
                <span>{{col.loading}}</span>
              </el-upload>
              <el-button type="primary" @click="submitUpload(index)">{{ $t('page.upload') }}</el-button>
            </div>

            <div class="description" v-html="typeof col.description == 'function' ? col.description(updateModel,col) : col.description"></div>

          </el-form-item>

          <!--自定义slot type:10-->
          <slot v-if="col.type == 10||col.hidden?(typeof col.hidden == 'function'?!col.hidden(updateModel,col):true):true"
                :name="col.slot" :col="col" :updateModel="updateModel"></slot>
          <div v-if="col.remarkType&&col.remarkTxt!=''" class="remarkType">
            <span v-html="col.remarkTxt"></span>
          </div>
        </div>
      </div>

    </el-form>

    <div v-show="!updateData.submit || updateData.submit == 'show'">
      <template  slot="footer" style="display: flex;justify-content: center;align-items: center;width: 100%">
        <el-button v-show="!updateData.cancel || updateData.cancel == 'show'" @click="close()">{{$t('page.cancel')}}</el-button>
        <el-button v-show="!submitBtn.hide" type="primary" @click="submit()" :disabled="submitBtn.disabled" :loading="submitBtn.loading">{{$t('page.submit')}}</el-button>
      </template>
    </div>
  </el-dialog>
</template>

<script>
import { getToken } from '@/utils/auth'
import { localRead, getQueryString } from '@/utils/tools'
import quill from "@/components/page/quill.vue"
import Url from "@/api/url"
import Ueditor from "@/components/page/ueditor.vue"
import tinyeditor from "@/components/page/tinymce_editor.vue"
import questionTemplate from '@/components/page/question_template.vue'
import newtaskTemplate from '@/components/page/newtask_template.vue'
import bannerTemplate from '@/components/page/banner_template.vue'
import taskTemplate from '@/components/page/task_detail.vue'

export default {
  components:{
    quill,
    Ueditor,
    tinyeditor,
    questionTemplate,
    newtaskTemplate,
    bannerTemplate,
    taskTemplate,
  },
  props: ["updateData","className"],
  data(){
    return{
      defaultUploadUrl:Url.img.upload,
      maxHeight:"",
      visible:false,
      formData:{cols:[]},
      colData:{},
      uploadHeaders:{},
      submitBtn: {
        loading: false,
        disabled: false,
        hide: false
      },
      title: '',
      cardNo: '',
      cardPwd: '',
      tab: 1,
      addFrom: '',
      isOpenFunction: false,
      editList: []
    }
  },
  computed:{
    updateModel:{
      get(){
        let obj = {};
        for (let i in this.formData.cols) {
          if (this.formData.cols[i].type == 8){
            let arr = this.formData.cols[i].data;
            for (let j in this.formData.cols[i].selectList){
              arr = arr.filter((item)=>{
                return item != this.formData.cols[i].selectList[j].check;
              });
            }
            obj[this.formData.cols[i].field] = arr;
          }

          if (this.formData.cols[i].type == 9) {
            if (!this.formData.cols[i].startEndParam) {
              obj[this.formData.cols[i].field + 'Start'] = this.formData.cols[i].data[0]
              obj[this.formData.cols[i].field + 'End'] = this.formData.cols[i].data[1]
            } else {
              obj[this.formData.cols[i].startEndParam[0]] = this.formData.cols[i].data ? this.formData.cols[i].data[0] : ''
              obj[this.formData.cols[i].startEndParam[1]] = this.formData.cols[i].data ? this.formData.cols[i].data[1] : ''
            }
            let value = this.formData.cols[i].isArray
            if (typeof (value) == 'undefined' || value === '' || value == null || value == true) {
              obj[this.formData.cols[i].field] = this.formData.cols[i].data
            } else {
              obj[this.formData.cols[i].field] = this.formData.cols[i].data.join(',')
            }
          }
          else obj[this.formData.cols[i].field] = this.formData.cols[i].data;
        }
        return obj;
      },
    },
    id() {
      const item = this.formData.cols.find(item => item.field === "id");
      return item ? item.data : "";
    },
    bigTaskId() {
      const item = this.formData.cols.find(item => item.field === "bigTaskId");
      return item ? item.data : "";
    },
    adId() {
      const item = this.formData.cols.find(item => item.field === "style");
      return item ? item.data : "";
    },
    adType() {
      const item = this.formData.cols.find(item => item.field === "adType");
      return item ? item.data : "";
    },
    taskName() {
      const item = this.formData.cols.find(item => item.field === "taskName");
      return item ? item.data : "";
    },
    gradeList() {
      const item = this.formData.cols.find(item => item.field === "grade");
      return item ? item.optionList : "";
    }
  },
  methods:{
    handleInput (value, col) {
      this.$set(col, 'data', value);
      if (col.onInput) {
        col.onInput(value, this.updateModel)
      }      
      this.change();
    },
    downTemplate(url){
      window.location.href = url;
    },
    docHeight() {
      let docHeight = window.innerHeight || document.documentElement.clientHeight
      this.maxHeight = docHeight / 1.8 + 'px'
    },
    //提交状态
    loading(){
      this.changeSubmitBtnStatus(true);
      this.disableSubmitBtnStatus(true);
    },
    beforeClose(done){
      this.changeSubmitBtnStatus(false);
      this.disableSubmitBtnStatus(false);
      if (this.updateData.beforeClose) {
        this.updateData.beforeClose(done);
      } else {
        done();
      }
    },
    close(){
      this.visible = false;
      //this.changeSubmitBtnStatus(false);
      this.disableSubmitBtnStatus(false);      
    },
    open(data,editList = []){
      this.isOpenFunction = true;
      this.submitBtn.hide = false;
      this.submitBtn.disabled = false;
      this.colData = data || {};
      this.visible = true;
      this.formData = {cols:[]};
      this.formData.modelName = this.updateData.modelName;
      this.cardNo = this.cardPwd = this.addFrom = ''; // 清空卡密
      this.tab = 1;
      this.editList = editList;
      for (let i in this.updateData.cols) {
        //更新操作，需要回显
        let assign = Object.assign(this.common.copy(this.updateData.cols[i]));
        if (this.colData[this.updateData.cols[i].field] !== undefined) {

          //存在回显数据，则更换默认值
          assign.data = this.colData[this.updateData.cols[i].field];
         
          if(assign.isCodeToText){
            console.log(assign.data+"--"+assign.isCodeToText[assign.data]);
            assign.data = assign.isCodeToText[assign.data] || assign.data;
          }
        }
        this.formData.cols.push(assign);
      }
      //处理多选框的全选回显样式
      for (let i in this.formData.cols) {
        console.log(this.formData.cols[i].data+"]]]]]");
        if (this.formData.cols[i].type == 8){
          this.handleCheckedCitiesChangeMu(this.formData.cols[i].data,this.formData.cols[i]);
        }else if(this.formData.cols[i].type == 4 && this.formData.cols[i].hasCheckAll){
          this.handleCheckedCitiesChange(this.formData.cols[i].data,this.formData.cols[i]);
        }else if(this.formData.cols[i].type == 11 && this.formData.cols[i].data && this.formData.cols[i].data.fileName){
          this.formData.cols[i].fileName = this.formData.cols[i].data.fileName;
        } else if(this.formData.cols[i].field == 'taskName' && this.colData.id ){
          this.formData.cols[i].data = this.formData.cols[i].data.replace(/perInformatin/g, '完善个人信息').replace(/verifIdentity/g, '实名认证');
        }
      }

      if (this.formData.cols.find(item => item.field === "adType")){
        this.changeAdType(this.isOpenFunction);
      }

      if (this.formData.cols.find(item => item.field === "platform") && this.$route.path === '/business/appUpdate/list') {
        this.$emit("changePlatform", {"platform":this.formData.cols.find(item => item.field === "platform").data,"version":this.formData.cols.find(item => item.field === "version").data}, this.isOpenFunction);
      }

      if (this.formData.cols.find(item => item.field === "accountLoginType") && this.$route.path === '/crs/productZoneInfo/list') {
        this.$emit("changeUnionGroup", {"businessType":this.formData.cols.find(item => item.field === "businessType").data,"accountLoginType":this.formData.cols.find(item => item.field === "accountLoginType").data}, this.isOpenFunction);
      }

      if (this.formData.cols.find(item => item.field === "groupCode") && this.$route.path === '/crs/productZoneInfo/list') {
        this.$emit("getProductList", {"groupCode":this.formData.cols.find(item => item.field === "groupCode").data}, this.isOpenFunction);
      }

      if (this.formData.cols.find(item => item.field === "businessType") && this.$route.path === '/crs/customerInfo/list') {
        this.$emit("changeCustomerType", {"businessType":this.formData.cols.find(item => item.field === "businessType").data}, this.isOpenFunction);
      }

      this.$nextTick(() => {
        let index = 0;
        for (let i in this.formData.cols) {
          if (this.formData.cols[i].type == 6 && !this.submitBtn.hide){
            this.$refs.quill[index].init(this.formData.cols[i].data);
            index ++;
          }
        }
        this.isOpenFunction = false
      });
    },
    change(){
      //此处数据需要强制刷新，否则监听不到数据变化，数据会出现无法输入
      this.$forceUpdate();
    },
    updateFormData(keys = "data",items) {
      items.forEach(item => {
        this.$set(this.formData.cols.find(c => c.field === item), keys, this.updateData.cols.find(c => c.field === item)[keys]);
      });
    },
    changeValue(updateModel,col,cols){
      if (col.change instanceof Function){
        col.change(updateModel,cols,col);
      }
    },
    dataRender(updateModel, col) {
      if (col.dataRender instanceof Function) {
        return col.dataRender(updateModel, col);
      } else {
        return col.data;
      }
    },
    pushArr(optionList,arr){
      if(optionList instanceof Array){
        for (let i in optionList) {
          arr.push(optionList[i].key);
        }
      }else{
        for (let i in optionList){
          arr.push(i);
        }
      }
    },
    getCheckAllArr(col){
      let optionList = [];
      if (col.optionList){
        this.pushArr(col.optionList,optionList);
      }else if (col.styleList){
        for (let i in col.styleList){
          if (col.styleList[i]){
            this.pushArr(col.styleList[i],optionList);
          }
        }
      }
      if (col.isNumber) optionList = optionList.map(key => {return Number(key)});
      return optionList;
    },
    selectAllOrRemoveAll(dataArr,selectArr,type){
      for (let i in selectArr) {
        if (type == 1) {//全选
          if (dataArr.indexOf(selectArr[i]) == -1) {
            dataArr.push(selectArr[i]);
          }
        }else{//全不选
          dataArr = dataArr.filter((item)=>{
            return item != selectArr[i];
          });
        }
      }
      return dataArr;
    },
    handleCheckAllChange(val,col){
      let optionList = this.getCheckAllArr(col);
      col.data = val ? optionList:[];
      col.isIndeterminate = false;
      this.$forceUpdate();
    },
    handleCheckAllChangeMu(val,select,col){
      let optionList = this.getCheckAllArr(select);
      if (col.isNumber) {
        col.data = col.data.map(key => {return Number(key)});
        optionList = optionList.map(key => {return Number(key)});
      }
      if (val){
        //全选
        col.data = this.selectAllOrRemoveAll(col.data,optionList,1);
      }else{
        //全不选
        col.data = this.selectAllOrRemoveAll(col.data,optionList,0);
      }
      select.isIndeterminate = false;
      this.$forceUpdate();
    },
    handleCheckedCitiesChangeMu(val,col) {
      let dataList = col.data;
      if (col.isNumber) dataList = col.data.map(key => {return Number(key)});
      for(let i in col.selectList){
        let optionList = this.getCheckAllArr(col.selectList[i]);
        if (col.isNumber) optionList = optionList.map(key => {return Number(key)});
        let flag = true;//是否全选
        let hasData = false;//是否有选中值
        let check = [col.isNumber?Number(col.selectList[i].check):col.selectList[i].check];
        for(let j in optionList){
          if (dataList.indexOf(optionList[j]) == -1) {
            flag = false;
            col.selectList[i].checkAll = false;
            col.data = this.selectAllOrRemoveAll(col.data,check,0);
          }else{
            hasData = true;
          }
        }
        if(flag) {
          col.selectList[i].checkAll = true;
          col.data = this.selectAllOrRemoveAll(col.data,check,1);
        }
        col.selectList[i].isIndeterminate = hasData && !flag;
      }
      this.$forceUpdate();
    },
    handleCheckedCitiesChange(val,col) {
      let optionList = this.getCheckAllArr(col);
      let checkedCount = val.length;
      col.checkAll = checkedCount === optionList.length;
      col.isIndeterminate = checkedCount > 0 && checkedCount < optionList.length;
      this.$forceUpdate();
    },
    changeSubmitBtnStatus(status){
      this.submitBtn.hide = status;
    },
    disableSubmitBtnStatus(status){
      this.submitBtn.disabled = status;
    },
    changeTitle(title) {
      this.title = title
    },
    changeHiddenStatus(){
      this.updateData.submit = "detail";
    },
    async submit(){
      let index = 0;
      for (let i in this.formData.cols) {
        if (this.formData.cols[i].type == 6){
          this.formData.cols[i].data = this.$refs.quill[index].getHtml();
          this.updateModel[this.formData.cols[i].field] = this.$refs.quill[index].getHtml();
          index ++;
        }
        if (this.formData.cols[i].type == 31 && this.$refs.task && this.$refs.task.length > 0){
          this.$refs.task[0].init();
        }

        // 处理兑换申请
        if (this.formData.cols[i].type == 32) {
          // 审批
          if (this.updateModel["approveChange"] === 2) {
            if (this.updateModel["exchangeType"] === 2) {
              if (this.cardNo && this.cardPwd) {
                this.updateModel[this.formData.cols[i].field] = `cardNo:${this.cardNo},cardPwd:${this.cardPwd}`;
              } else {
                this.alert(typeof this.formData.cols[i].title == 'function' ? this.formData.cols[i].title(this.updateModel):this.formData.cols[i].title, this.formData.cols[i].errorMsg)
                return;
              }
            } else {
              this.updateModel[this.formData.cols[i].field] = this.formData.cols[i].data;
            }
            // 审批内容必填
          } else {
            // 取消3
            this.updateModel[this.formData.cols[i].field] = this.formData.cols[i].data;
          }
        }
      }
      this.$forceUpdate();
      for (let i in this.formData.cols) {
        let required = typeof this.formData.cols[i].required == 'function'?this.formData.cols[i].required(this.updateModel,this.formData.cols[i]):this.formData.cols[i].required;
        if (required){
          //包含必填验证
          if (Array.isArray(this.updateModel[this.formData.cols[i].field]) && this.updateModel[this.formData.cols[i].field].length <= 0) {
            if (this.updateModel[this.formData.cols[i].field].length <= 0) {
              //空数据
              this.alert(typeof this.formData.cols[i].title == 'function' ? this.formData.cols[i].title(this.updateModel):this.formData.cols[i].title, this.formData.cols[i].errorMsg)
              return
            }
          } else {
            let value = this.updateModel[this.formData.cols[i].field];
            if (typeof (value) == 'undefined' || value === '' || value == null) {
              //空数据
              this.alert(typeof this.formData.cols[i].title == 'function' ? this.formData.cols[i].title(this.updateModel):this.formData.cols[i].title, this.formData.cols[i].errorMsg)
              return
            }
          }
        }

        // 手动替换banners中的bannerId为id
        if (this.formData.cols[i].field == "banners") {
          if (Array.isArray(this.formData.cols[i].data)) {
            this.updateModel[this.formData.cols[i].field].forEach(item => {
              if ('bannerId' in item) {
                item.id = item.bannerId;                
                delete item.bannerId;
              }
              item.isDelete = item.bannerDelete;
            });
          } else if (this.formData.cols[i].data === null) {
            this.formData.cols[i].data = [];
          }
        }
      }
      
      if (this.className && this.className === '米星卡等级' && this.id) {
        const sorted = [...this.editList].sort((a, b) => a.grade - b.grade);
        if (sorted[0].scoreRangeBegin !== 0) {
          this.$message.error("grade1 的起始值必须为0");
          return;
        }
        for (let i = 0; i < sorted.length - 1; i++) {
          if (sorted[i].scoreRangeEnd + 1 !== sorted[i + 1].scoreRangeBegin) {
            this.$message.error(`grade${sorted[i].grade} 和 grade${sorted[i+1].grade} 区间不连续`);
            return;
          }
        }
        this.disableSubmitBtnStatus(true);
        this.$emit("submit", JSON.parse(JSON.stringify(this.editList)), "miCardLevel");
      } else if (this.className && this.className === '兑换申请' && this.updateModel.approveChange === 2) {
        try {
          this.close();
          await this.$confirm(`您将要提交的${this.updateModel.exchangeType === 1 ? '充值金额' : '兑换码'}是: ${this.updateModel.remark}`, '确认提交', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          });
          this.disableSubmitBtnStatus(true);
          this.$emit("submit", JSON.parse(JSON.stringify(this.updateModel)));
        } catch (error) {
          this.visible = true;
        }
      } else {
        this.disableSubmitBtnStatus(true);
        this.$emit("submit", JSON.parse(JSON.stringify(this.updateModel)));
      }
    },
    alert(title, errorMsg){
      this.$alert(errorMsg || (window.$t('page.write') + title), window.$t('page.validate'), {
        confirmButtonText: window.$t('page.enter'),
        callback: action => {
        }
      });
    },
    uploadSuc(response, file, fileList, col){
      if (response.code == 0){
        this.$set(col, "data", response.result);
        col.loading = "";
      }else{
        console.log("====上传失败")
        col.loading = window.$t('page.uploadFail');
      }
      this.$forceUpdate();
    },
    uploadFileSuc(response, file, fileList,col){
      if (response.code == 0){
        col.loading = "";
        this.$message.success(window.$t('page.uploadSuc'));
      }else{
        col.loading = window.$t('page.uploadFail');
      }
      this.$forceUpdate();
      this.$emit("uploadFile",col,response.result);
    },
    uploadProgress(file, col, maxfileSize = 100, accept = ''){
      const fileSize = file.size / 1024 / 1024;
      if (accept){
        const extension = accept.split(',').map(item => item.replace('.',''));
        const fileType = (file.type.split('/')[1]).replace("vnd.android.package-archive","apk");
        if (!extension.includes(fileType)){
          this.$message.error(`只能上传${accept}`);
          return false;
        }
      }
      if (fileSize > maxfileSize){
        this.$message.error(`文件大小不能超过${maxfileSize}M`);
        return false;
      }
      col.loading = window.$t('page.uploading');
      this.$forceUpdate();
    },
    uploadFileProgress(file,col){
      col.loading = window.$t('page.uploading');
      col.fileName = file.name;
      this.$forceUpdate();
    },
    uploadFail(response, file, fileList,col){
      col.loading = window.$t('page.uploadFail');
      this.$message.error(window.$t('page.uploadFail'));
      this.$forceUpdate();
    },
    uploadMediaSuc(response, file, fileList, col){
      if (response.code == 0){
        col.loading = "";
        this.$message.success(window.$t('page.uploadSuc'));
      }else{
        col.loading = window.$t('page.uploadFail');
      }

      const data = {
        name: file.raw.name,
        type: file.raw.type,
        size: file.raw.size,
        lastModified: file.raw.lastModified,
        url: response.result,
      }
      this.$set(col, "data", data);

      if (col.mediaType === 0 || col.mediaType === 1) {
        // get media duration
        const tagName = col.mediaType === 0 ? "video" : "audio";
        var media = document.createElement(tagName);
        media.preload = 'metadata';

        media.onloadedmetadata = () => {
          window.URL.revokeObjectURL(media.src);
          var duration = Math.trunc(media.duration);
          this.$set(col.data, "duration", duration);
        }

        media.src = window.URL.createObjectURL(file.raw);
      }

      this.$forceUpdate();
      this.$emit("uploadMedia", col, response.result, file, this.formData.cols);
    },
    changeFrom(value) {
      this.addFrom = value;
      this.$forceUpdate();
    },
    openDemo(){
      this.$alert('<img width="100%" src="https://images.miduoxing.com/upload/UAT/mis/2025710/1752129152278.png">','奖品详情示例', {
        dangerouslyUseHTMLString: true,
        customClass: 'custom-alert'
      });
    },
    changeAdType(isOpenFunction){
      if (this.adType === 1){
        this.$set(this.formData.cols.find(c => c.field === "spModel"), "optionList", {"1":"半屏","2":"全屏"});
        this.$set(this.formData.cols.find(c => c.field === "adLocation"), "data", 1);
        this.$set(this.formData.cols.find(c => c.field === "adLocation"), "optionList", { "1": "启动页" });
      } else if (this.adType === 2) {
        this.$set(this.formData.cols.find(c => c.field === "spModel"), "optionList", {"1":"横屏","2":"竖屏"});
        this.$set(this.formData.cols.find(c => c.field === "adLocation"), "optionList", { "3": "首页", "6": "我的", "8": "任务中心", "9": "兑换中心" });
      } else if (this.adType === 4) {
        this.$set(this.formData.cols.find(c => c.field === "adLocation"), "data", 12);
        this.$set(this.formData.cols.find(c => c.field === "spModel"), "optionList", {"3":"顶部","4":"中部","5":"底部"});
      } else if (this.adType === 5) {
        //浮窗广告
        this.$set(this.formData.cols.find(c => c.field === "spModel"), "optionList", {"1":"右下角"});
        this.$set(this.formData.cols.find(c => c.field === "adLocation"), "optionList", { "3": "首页", "6": "我的", "8": "任务中心", "9": "兑换中心" });
      } else if (this.adType === 6) {
        //跑马灯
        this.$set(this.formData.cols.find(c => c.field === "spModel"), "optionList", {"3":"顶部","5":"底部"});
        this.$set(this.formData.cols.find(c => c.field === "adLocation"), "optionList", { "3": "首页", "4": "任务完成页", "8": "任务中心", "9": "兑换中心" });
      } else {
        this.$set(this.formData.cols.find(c => c.field === "spModel"), "optionList", {"3":"顶部","4":"中部","5":"底部"});
      }

      if (this.adType != 1 && this.adType != 2 && this.adType != 5 && this.adType != 6) {
        this.$set(this.formData.cols.find(c => c.field === "adLocation"), "optionList", { "2": "登陆/注册", "3": "首页", "4": "任务完成页", "5": "赚米学堂", "6": "我的", "7": "消息中心", "8": "任务中心", "9": "兑换中心", "10": "任务记录", "11": "兑换记录", "12": "任务详情", "13": "奖品详情" });
      }

      if (!isOpenFunction) {
        this.$set(this.formData.cols.find(c => c.field === "spModel"),"data","");
        if (this.adType != 1 && this.adType != 4) {
          this.$set(this.formData.cols.find(c => c.field === "adLocation"), "data", "");
        }
      }
    },
    submitUpload(index) {
      const uploadRef = this.$refs[`upload${index}`][0];
      uploadRef.submit();
    },
  },
  mounted() {
    this.docHeight();
    if (localRead('sysToken')) {
      this.uploadHeaders.Authorization = localRead('sysToken');
    }else if (window.SITE_CONFIG['routerLabel']) {
      this.uploadHeaders.Authorization =  getToken(window.SITE_CONFIG['routerLabel'])
    } else if (window.location.href.indexOf('label') != -1) {
      let labelRouter = getQueryString('label')
      this.uploadHeaders.Authorization = getToken(labelRouter)
    }
    this.$forceUpdate();
  },
  watch: {
    bigTaskId: {
      handler() {
        if (!this.colData.id){
          for (let i in this.formData.cols) {
            if (this.formData.cols[i].type == 31) {
              this.$set(this.formData.cols[i], 'data', '');
            }
          }
        }
      }
    },
    adType: {
      handler() {
        this.changeAdType(this.isOpenFunction)
      }
    }
  }
}
/* 用法说明
<UPDATE  ref="childUpdate"  @submit="submit" :updateData="updateData"></UPDATE>
methods: {
    //结合table组件点击跟新按钮
    bthClick (clickName, row) {
        console.log(clickName,row);
        if (clickName == "update"){
            //弹出更新数据框并回显数据
            this.$refs.childUpdate.open(row);
        }
    },
    /!*提交数据触发事件*!/
    submit(model){
        console.log(model);
        //根据是否包含id更新还是添加
    }
},
data () {
      return {
        updateData:{
            cols:[
            //title：数据框显示名称, filed：name属性（与后台查询字段名称对应）, type:数据框选项{1:普通 2:select 3:单选 4:复选 5:时间，6:富文本},upload:是否需要上传图片功能，action:上传图片接口地址，新增需要添加定义初始值时data字段定义
                { title: 'id', field: 'id',hidden:true},
                { title: '手机号', field: 'phone',type: 6},
                { title: '证件号', field: 'idNumber'},
                { title: '是否启用', field: 'status',type:3,optionList:DataUtil.whiteList.status,isNumber:true},
                { title: '备注', field: 'remark',upload:true,action:'http://precrs.will68.com/public/card/upload'},
                { title: '邮箱', field: 'email',upload:true,action:'http://precrs.will68.com/public/card/upload'},
                { title: '富文本', field: 'text',type: 6},
            ]
        }
      ｝
*/
</script>
<style>
.dv_update .el-form-item{
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.dv_update .el-form-item__content{
  width: 78%;
}
.dv_update .newLine .el-form-item__content{
  width: 100%;
}
.dv_update .el-form-item.newLine{
  flex-wrap: wrap;
  justify-content: flex-start;
}
.dv_update .newLine .el-form-item__label{
  width: 100%;
  background: #fbfbfb;
  text-align: left;
  padding: 0 15px;
  border: solid 1px #e6e6e6;
}
.dv_update .el-upload-dragger{width: 200px;}
.dv_update .el-dialog__footer{
  display: flex;
  justify-content: center;
  align-items: center;
}
.dv_update .el-dialog {
  min-width: 800px;
}

.el-dialog__footer{
  display: flex;
  justify-content: center;
  align-items: center;
}
#edui_fixedlayer{z-index: 9999999!important;}

.banner-images-box .avatar-uploader {
  display: flex;
  line-height: normal;
}
.banner-images-box .el-icon-upload {
  width: 40px; 
  height: 40px; 
  border: 1px dashed #d9d9d9; 
  border-radius: 2px; 
  cursor: pointer; 
  display: flex; 
  justify-content: center; 
  align-items: center;
}
.dv_update .el-form-item__label{
  white-space: nowrap;
}

.exchange_record .price {
  display: flex;
  margin: 5px 0;
}

.description {
  line-height: 22px;
}

.task .el-dialog__body {
  padding-top: 10px;
}
.task .tabs {
  display: flex; 
  border-bottom: solid 1px #DCDFE6; 
  gap: 15px; 
  margin-bottom: 15px; 
  padding-bottom: 10px;
}
.task .tabs span {
  cursor: pointer;
}
.task .tabs .active{
  color: var(--brand-primary);
  font-weight: bold;
}
.custom-alert {
  width: 680px !important;
}

.miCardLevel {
  margin-bottom: 20px;
}
.miCardLevel table tr.title td {
  font-weight: bold;
}
.miCardLevel table td {
  height: 40px;
}
</style>